import { _callFile, _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';
import type { Activity } from '@/_types/models/activitites';

interface ActivityLogsResponse {
  activities: Array<Activity>;
  total: number;
  per_page: number;
  current_page: number;
}

export const getActivities = async ({
  token,
  company_id,
  page = 0,
  per_page = 32,
  questionnaire_id,
  type_id,
  search,
}: APIRequest<{
  company_id?: number;
  page?: number;
  per_page?: number;
  questionnaire_id?: number;
  type_id?: string;
  search?: string;
}>): APIResponsePromise<ActivityLogsResponse> => {
  const searchParams = new URLSearchParams({
    page: page.toString(),
    per_page: per_page.toString(),
    ...(company_id && { company_id: company_id.toString() }),
    ...(questionnaire_id && {
      questionnaire_id: questionnaire_id.toString(),
    }),
    ...(type_id && { type_id: type_id.toString() }),
    ...(search && { search }),
  });

  return await _callBackend(
    `/v2/activity_logs?${searchParams.toString()}`,
    'GET',
    null,
    token,
  );
};
